export default __webpack_public_path__ + "static/media/placeholder_business02-it-web.7b1c44dd.png";